module.exports = __webpack_public_path__ + "img/分区02.ea85fce9.png";